"use client";
import React, { FC, ReactNode } from "react";
import { FlexCol } from "./ui";
import { useSession } from "next-auth/react";
import { useModalStore } from "@/store";
import {
  IBaseIsLoggedInProps,
  IBaseNavigateToLoggedInProps,
  IBaseTextContent,
} from "@/interfaces";
import { cn } from "@/lib";

interface IChildrenProps
  extends IBaseIsLoggedInProps,
    IBaseNavigateToLoggedInProps {}

interface ServicesPagesFormSegmentProps extends IBaseTextContent {
  children: (props: IChildrenProps) => ReactNode;
  className?: string;
}

const ServicesPagesFormSegment: FC<ServicesPagesFormSegmentProps> = ({
  title,
  description,
  children,
  className,
}) => {
  const { status } = useSession();
  const isLoggedIn: boolean = status === "authenticated";
  const { setOpenModal } = useModalStore();
  const navigateToLogin = () => {
    setOpenModal("send-otp-modal");
  };

  return (
    <div
      className={cn(
        `from-emerald-mint relative rounded-2xl bg-linear-to-b to-transparent p-[2px]`,
        className,
      )}
    >
      <FlexCol className="size-full items-center rounded-xl bg-white p-6 sm:p-8">
        <h2 className="mb-2 text-sm font-bold md:mb-4 md:text-base xl:mb-5 xl:text-xl">
          {title}
        </h2>
        <p className="text-custom-gray-200 mb-5 text-xs md:text-sm xl:text-base">
          {description}
        </p>
        <div className="w-full">
          {children({ isLoggedIn, navigateToLogin })}
        </div>
      </FlexCol>
    </div>
  );
};

export default ServicesPagesFormSegment;
